<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 32 32"
    role="presentation"
    :fill="iconColor">
    <defs>
        <path id="container-a" d="M1.576 6.302h28.36V25.21H1.576V6.302zm3.15 3.152v12.604h22.059V9.454H4.727zm3.152 0h3.151v12.604H7.878V9.454zm3.151 12.604H7.878h3.151zM14.18 9.454h3.151v12.604h-3.15V9.454zm3.151 12.604h-3.15 3.15zm3.152-12.604h3.15v12.604h-3.15V9.454zm0 0h3.15-3.15zm3.15 12.604h-3.15 3.15z"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path d="M-178-905h2331V67H-178z"/>
        <g>
            <mask id="container-b" fill="#fff">
                <use xlink:href="#container-a"/>
            </mask>
            <use fill="#DEE0E0" fill-rule="nonzero" xlink:href="#container-a"/>
            <g :fill="iconColor" mask="url(#container-b)">
                <path d="M0 0h31.512v31.512H0z"/>
            </g>
        </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '32px'
    },
    height: {
      type: [Number, String],
      default: '32px'
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
